// Auto-save para o formulário de reuniões
document.addEventListener('DOMContentLoaded', function () {
  // Busca o formulário de reunião
  const form = document.querySelector('#new_meeting, .edit_meeting');

  // Se não encontrar o formulário, não prossegue
  if (!form) return;

  // ========== INÍCIO DO AUTO-SAVE (código existente) ==========

  // Obtém a URL base do formulário
  const formAction = form.getAttribute('action');

  // Constrói a URL para o endpoint de autosave corretamente
  const autosaveUrl = `${formAction}/autosave`;

  console.log('URL de autosave:', autosaveUrl); // Debug

  // Obtém o token CSRF para Rails
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  // Variáveis para controle de debounce e estado de salvamento
  let saveTimeout;
  let isSaving = false;

  // Cria o elemento de feedback
  const createFeedbackElement = () => {
    if (!document.getElementById('auto-save-feedback')) {
      const feedbackDiv = document.createElement('div');
      feedbackDiv.id = 'auto-save-feedback';
      feedbackDiv.style.position = 'fixed';
      feedbackDiv.style.bottom = '20px';
      feedbackDiv.style.right = '20px';
      feedbackDiv.style.padding = '10px 15px';
      feedbackDiv.style.borderRadius = '4px';
      feedbackDiv.style.backgroundColor = '#f8f9fa';
      feedbackDiv.style.border = '1px solid #ddd';
      feedbackDiv.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      feedbackDiv.style.zIndex = '1050';
      feedbackDiv.style.display = 'none';
      document.body.appendChild(feedbackDiv);
    }
    return document.getElementById('auto-save-feedback');
  };

  // Exibe mensagem de feedback
  const showFeedback = (message, isError = false) => {
    const feedbackElement = createFeedbackElement();
    feedbackElement.textContent = message;
    feedbackElement.style.backgroundColor = isError ? '#f8d7da' : '#d4edda';
    feedbackElement.style.borderColor = isError ? '#f5c6cb' : '#c3e6cb';
    feedbackElement.style.color = isError ? '#721c24' : '#155724';
    feedbackElement.style.display = 'block';

    // Esconde após 3 segundos
    setTimeout(() => {
      feedbackElement.style.display = 'none';
    }, 3000);
  };

  // Salva os dados do formulário
  const saveFormData = () => {
    // Evita múltiplos salvamentos simultâneos
    if (isSaving) return;

    isSaving = true;
    showFeedback('Salvando...');

    // Serializa os dados do formulário
    const formData = new FormData(form);

    // Adiciona o status como opened durante o auto-save
    formData.set('meeting[status]', 'opened');

    fetch(autosaveUrl, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro na resposta do servidor: ' + response.status);
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          showFeedback('Dados salvos automaticamente');
        } else {
          console.log(data);
          showFeedback('Erro ao salvar dados', true);
        }
      })
      .catch(error => {
        console.log(error);
        console.error('Erro ao salvar dados:', error);
        showFeedback('Erro ao salvar dados', true);
      })
      .finally(() => {
        isSaving = false;
      });
  };

  // Agenda o auto-save com debounce
  const scheduleAutoSave = () => {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(saveFormData, 1000); // Espera 1 segundo após a última alteração
  };

  // Adiciona os event listeners aos campos do formulário
  const attachListeners = () => {
    // Campos de texto, número e textarea
    form.querySelectorAll('input[type="text"], input[type="number"], textarea').forEach(input => {
      input.addEventListener('input', scheduleAutoSave);
    });

    // Editor Trix (ActionText)
    form.querySelectorAll('trix-editor').forEach(editor => {
      editor.addEventListener('trix-change', scheduleAutoSave);
    });

    // Checkboxes e radio buttons
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
      input.addEventListener('change', scheduleAutoSave);
    });

    // Selects (incluindo bootstrap-select)
    form.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', scheduleAutoSave);

      // Para bootstrap-select
      if (select.classList.contains('selectpicker')) {
        // Evento específico do bootstrap-select
        $(select).on('changed.bs.select', scheduleAutoSave);
      }
    });
  };

  // Inicializa os listeners do auto-save
  attachListeners();

  // ========== FIM DO AUTO-SAVE ==========

  // ========== INÍCIO DA VALIDAÇÃO ==========

  // Busca o botão de submit
  const submitButton = form.querySelector('input[type="submit"][value="Salvar Respostas"]');

  // Se não encontrar o botão, não prossegue com a validação
  if (!submitButton) return;

  // Função para obter o label de um campo
  const getFieldLabel = (field) => {
    const formGroup = field.closest('.form-group') || field.closest('.col-lg-4') || field.closest('.col-lg-12');
    const label = formGroup?.querySelector('label');
    return label ? label.textContent.replace(' *', '').trim() : 'Campo';
  };

  // Função para validar o formulário
  const validateForm = (event) => {
    const camposVazios = [];
    let formValido = true;

    // Remove alertas anteriores
    const alertaAnterior = document.querySelector('.meeting-validation-alert');
    if (alertaAnterior) {
      alertaAnterior.remove();
    }

    // Validar campos de texto (field_string)
    form.querySelectorAll('input[name*="[field_string]"]').forEach(field => {
      if (!field.value.trim()) {
        formValido = false;
        const label = getFieldLabel(field);
        const topicName = field.closest('.card')?.querySelector('.card-header h6')?.textContent || '';
        camposVazios.push(`${topicName} - ${label}`);
        field.classList.add('is-invalid');
      } else {
        field.classList.remove('is-invalid');
      }
    });

    // Validar campos numéricos (field_number)
    form.querySelectorAll('input[name*="[field_number]"]').forEach(field => {
      if (!field.value.trim()) {
        formValido = false;
        const label = getFieldLabel(field);
        const topicName = field.closest('.card')?.querySelector('.card-header h6')?.textContent || '';
        camposVazios.push(`${topicName} - ${label}`);
        field.classList.add('is-invalid');
      } else {
        field.classList.remove('is-invalid');
      }
    });

    // Validar rich text areas (Trix Editor)
    // form.querySelectorAll('trix-editor').forEach(editor => {
    //   const content = editor.editor.getDocument().toString().trim();
    //   if (!content || content === '\n' || content === '') {
    //     formValido = false;
    //     const label = getFieldLabel(editor);
    //     const topicName = editor.closest('.card')?.querySelector('.card-header h6')?.textContent || '';
    //     camposVazios.push(`${topicName} - ${label}`);
    //     editor.classList.add('is-invalid');
    //   } else {
    //     editor.classList.remove('is-invalid');
    //   }
    // });

    // Validar selects de modelo (field_model)
    form.querySelectorAll('select[name*="[field_model]"]').forEach(select => {
      if (select.multiple) {
        const selectedOptions = Array.from(select.selectedOptions);
        if (selectedOptions.length === 0 || !select.value) {
          formValido = false;
          const label = getFieldLabel(select);
          const topicName = select.closest('.card')?.querySelector('.card-header h6')?.textContent || '';
          camposVazios.push(`${topicName} - ${label}`);

          const bootstrapSelect = select.closest('.form-group')?.querySelector('.bootstrap-select');
          if (bootstrapSelect) {
            bootstrapSelect.classList.add('is-invalid');
          }
        } else {
          const bootstrapSelect = select.closest('.form-group')?.querySelector('.bootstrap-select');
          if (bootstrapSelect) {
            bootstrapSelect.classList.remove('is-invalid');
          }
        }
      }
    });

    // Validar selects simples (field_select)
    form.querySelectorAll('select[name*="[field_select]"]').forEach(select => {
      if (!select.value || select.value === '') {
        formValido = false;
        const label = getFieldLabel(select);
        const topicName = select.closest('.card')?.querySelector('.card-header h6')?.textContent || '';
        camposVazios.push(`${topicName} - ${label}`);

        const bootstrapSelect = select.closest('.form-group')?.querySelector('.bootstrap-select');
        if (bootstrapSelect) {
          bootstrapSelect.classList.add('is-invalid');
        }
      } else {
        const bootstrapSelect = select.closest('.form-group')?.querySelector('.bootstrap-select');
        if (bootstrapSelect) {
          bootstrapSelect.classList.remove('is-invalid');
        }
      }
    });

    // Validar lista de presença
    const checkboxes = form.querySelectorAll('input[type="checkbox"][name*="[user_ids]"]:checked');
    if (checkboxes.length === 0) {
      formValido = false;
      camposVazios.push('Lista de presença (selecione pelo menos um participante)');

      const checkboxGroup = form.querySelector('.enhancedCheckbox');
      if (checkboxGroup) {
        checkboxGroup.classList.add('border', 'border-danger', 'p-2');
      }
    } else {
      const checkboxGroup = form.querySelector('.enhancedCheckbox');
      if (checkboxGroup) {
        checkboxGroup.classList.remove('border', 'border-danger', 'p-2');
      }
    }

    // Se houver campos vazios, mostrar alerta e cancelar submit
    if (!formValido) {
      event.preventDefault();
      event.stopPropagation();

      // Criar alerta
      const alertDiv = document.createElement('div');
      alertDiv.className = 'meeting-validation-alert alert alert-danger alert-dismissible fade show';
      alertDiv.setAttribute('role', 'alert');
      alertDiv.style.marginTop = '20px';

      let alertHTML = '<strong><i class="bi bi-exclamation-triangle-fill"></i> Atenção!</strong> Por favor, preencha todos os campos obrigatórios:';
      alertHTML += '<ul class="mb-0 mt-2">';

      // Remover duplicatas
      const camposUnicos = [...new Set(camposVazios)];
      camposUnicos.forEach(campo => {
        alertHTML += `<li>${campo}</li>`;
      });

      alertHTML += '</ul>';
      alertHTML += '<button type="button" class="close" data-dismiss="alert" aria-label="Close">';
      alertHTML += '<span aria-hidden="true">&times;</span>';
      alertHTML += '</button>';

      alertDiv.innerHTML = alertHTML;

      // Inserir alerta no topo do formulário
      const firstBlock = form.querySelector('.block');
      if (firstBlock) {
        form.insertBefore(alertDiv, firstBlock);
      } else {
        form.insertBefore(alertDiv, form.firstChild);
      }

      // Scroll suave para o alerta
      alertDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Focar no primeiro campo inválido após um delay
      setTimeout(() => {
        const primeiroInvalido = form.querySelector('.is-invalid');
        if (primeiroInvalido) {
          primeiroInvalido.scrollIntoView({ behavior: 'smooth', block: 'center' });
          primeiroInvalido.focus();
        }
      }, 500);

      return false;
    }

    // Se tudo estiver válido, mudar o status para closed
    const statusField = form.querySelector('input[name="meeting[status]"]');
    if (statusField) {
      statusField.value = 'closed';
    }

    return true;
  };

  // Adicionar evento de validação APENAS para o botão "Salvar Respostas"
  form.addEventListener('submit', function (event) {
    // Verificar se o submit veio do botão correto
    if (event.submitter === submitButton) {
      return validateForm(event);
    }
    return true;
  });

  // Remover classe de erro ao preencher os campos
  const addValidationListeners = () => {
    // Campos de texto e número
    form.querySelectorAll('input[name*="[field_string]"], input[name*="[field_number]"]').forEach(field => {
      field.addEventListener('input', function () {
        if (this.value.trim()) {
          this.classList.remove('is-invalid');
        }
      });
    });

    // Trix editors
    // form.querySelectorAll('trix-editor').forEach(editor => {
    //   editor.addEventListener('trix-change', function () {
    //     const content = this.editor.getDocument().toString().trim();
    //     if (content && content !== '\n') {
    //       this.classList.remove('is-invalid');
    //     }
    //   });
    // });

    // Selects
    form.querySelectorAll('select[name*="[field_model]"], select[name*="[field_select]"]').forEach(select => {
      select.addEventListener('change', function () {
        if (this.value) {
          const bootstrapSelect = this.closest('.form-group')?.querySelector('.bootstrap-select');
          if (bootstrapSelect) {
            bootstrapSelect.classList.remove('is-invalid');
          }
        }
      });

      // Para bootstrap-select
      if ($(select).data('selectpicker')) {
        $(select).on('changed.bs.select', function () {
          if (this.value) {
            const bootstrapSelect = this.closest('.form-group')?.querySelector('.bootstrap-select');
            if (bootstrapSelect) {
              bootstrapSelect.classList.remove('is-invalid');
            }
          }
        });
      }
    });

    // Checkboxes
    form.querySelectorAll('input[type="checkbox"][name*="[user_ids]"]').forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        const checkboxesChecked = form.querySelectorAll('input[type="checkbox"][name*="[user_ids]"]:checked');
        if (checkboxesChecked.length > 0) {
          const checkboxGroup = form.querySelector('.enhancedCheckbox');
          if (checkboxGroup) {
            checkboxGroup.classList.remove('border', 'border-danger', 'p-2');
          }
        }
      });
    });
  };

  // Adicionar indicadores visuais de campos obrigatórios
  const addRequiredIndicators = () => {
    // Adicionar asteriscos aos labels
    form.querySelectorAll('label').forEach(label => {
      const forAttr = label.getAttribute('for');
      if (forAttr &&
        (forAttr.includes('field_string') ||
          forAttr.includes('field_number') ||
          // forAttr.includes('field_text') ||
          forAttr.includes('field_model') ||
          forAttr.includes('field_select'))) {
        if (!label.innerHTML.includes('*')) {
          label.innerHTML += ' <span class="text-danger">*</span>';
        }
      }
    });

    // Lista de presença
    const listaPresencaTitle = Array.from(document.querySelectorAll('.block-title'))
      .find(el => el.textContent.includes('Lista de presença'));

    if (listaPresencaTitle && !listaPresencaTitle.innerHTML.includes('*')) {
      listaPresencaTitle.innerHTML += ' <span class="text-danger">*</span>';
    }
  };

  // Inicializar validação
  addValidationListeners();
  addRequiredIndicators();

  // CSS para validação
  const style = document.createElement('style');
  style.textContent = `
    .is-invalid {
      border-color: #dc3545 !important;
    }
    .bootstrap-select.is-invalid .dropdown-toggle {
      border-color: #dc3545 !important;
    }
    trix-editor.is-invalid {
      border: 1px solid #dc3545 !important;
    }
    .meeting-validation-alert {
      animation: slideDown 0.3s ease-out;
    }
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);

  // ========== FIM DA VALIDAÇÃO ==========
});